// Polyfills
import 'es6-promise/auto'

import 'core-js'

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach
}

// https://github.com/fregante/object-fit-images
import objectFitImages from 'object-fit-images'

import ButtonController from 'common/Button/ButtonController'
import MainNavController from 'marketing/MainNav/MainNavController'
import ModalSignUp from 'marketing/ModalSignUp/ModalSignup'
import VideoController from 'common/Video/VideoController'
import Hamburgers from 'common/Hamburgers/hamburgers'
import LogoSlidingCarouselController from 'marketing/LogoSlidingCarousel/LogoSlidingCarouselController'
import BlogPostCarousel from 'marketing/BlogPostCarousel/BlogPostCarouselController'
import StickyVideo from 'marketing/StickyVideo/StickyVideoController'
import Modal from 'common/Modal/Modal'
import SubNavController from '../components/marketing/SubNav/SubNavController'
import PcaPredict from 'common/PcaPredict/PcaPredict'
import PcaPredictController from 'common/PcaPredict/PcaPredictController'

import { supportsTouch } from 'utils.js'

$(document).ready(() => {
  objectFitImages()
  $('html').toggleClass('touch', supportsTouch)

  window.zd = {
    ...window.zd,
    Modal,
    ModalSignUp,
    StickyVideo,
    PcaPredict,
  }
  /* eslint-disable no-new */

  new ButtonController()
  new MainNavController()
  new VideoController()
  new Hamburgers()
  new LogoSlidingCarouselController()
  new BlogPostCarousel()
  new SubNavController()
  new PcaPredictController()
  /* eslint-enable no-new */
})
